<template lang='pug'>
//- 完成註冊區塊
div(:class='$style[`cc-popbox-uploader`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-title`]')
    span.font-bold(:class='$style[`cc-banner-main-title`]')
      span.no-wrap 選擇
      span.font-doctor-theme 上傳
      span.font-normal-theme 照片

    span.font-bold(:class='$style[`cc-banner-main-subtitle`]')

  div(:class='$style[`cc-uploader-content`]')
    div(:class='[$style[`cc-uploader-area`], $style[fileOnDrag ? `isOnDrag` : ``]]')
      input(
        type='file'
        ref='userAvatar'
        name='thumbSrc'
        :class='$style[`cc-uploader-inputer`]'
        @dragenter='handleDragEnter'
        @dragleave='handleDragLeave'
        @dragdrop='handleDragDrop'
        @change='handleChange')

      div(v-if='filePreviewSrc' :class='$style[`cc-uploader-preview`]')
        img(:src='filePreviewSrc' width='100%' height='100%')
      div(v-else :class='$style[`cc-uploader-interface`]')
        IconUpload(:size='40' :color='`#dcdcdc`')
        span(:class='[$style[`cc-uploader-title`], $style[showErrorMsg ? `isError` : ``]]') {{ fileTips }}
        span(:class='$style[`cc-uploader-tip`]') 僅支援JPG/PNG格式，寬高須相同且像素大於300*300的圖片

  div(:class='$style[`cc-content-controller`]')
    button(
      title='使用預設頭像'
      tabindex='0'
      aria-label='使用預設頭像'
      :class='$style[`cc-controller-default`]'
      @click.once='removeUploadFileProcess')
      span 使用預設頭像

    button(
      title='確認送出'
      tabindex='0'
      :aria-label='showLoading ? `處理中` : `確認送出`'
      :class='[$style[`cc-controller-confirm`], $style[!canUpload ? `cc-content-disabled` : ``]]'
      @click.once='startUploadFileProcess')
      IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
      span(v-else) 確認送出

</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import GlobalEmitter from 'tiny-emitter/instance';
// import axios from 'axios';

import IconUpload from '../../icon/Upload';
import IconLoading from '../../icon/Loading';

import {
  putAvatarUpload,
  getAvatarHistory,
  removeAvatarUpload,
} from '../../../js/restapi';

export default {
  components: {
    IconUpload,
    IconLoading,
  },

  data() {
    return {
      showLoading: false,

      avatarFiles: [],
      filePreviewSrc: '',
      fileTips: '拖曳或點擊上傳',
      fileOnDrag: false,
      showErrorMsg: false,
      canUpload: false,
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    handleUploadFile() {
      this.fileOnDrag = false;
      this.showErrorMsg = false;

      const file = this.avatarFiles[0];
      // const newFileName = file.name.replace(/\.[^/.]+$/, '');

      if (file.type === '' || file.type === 'image/jpeg' || file.type === 'image/png') {
        const vm = this;
        // eslint-disable-next-line no-underscore-dangle
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.src = _URL.createObjectURL(file);

        // eslint-disable-next-line func-names
        img.onload = function () {
          const imgWidth = this.width;
          const imgHeight = this.height;

          if (file.size < (1500 * 1024)) {
            if (imgWidth !== imgHeight) {
              vm.showErrorMsg = true;
              vm.fileTips = '照片寬高必須相等';
            } else {
              vm.fileTips = file.name;
              vm.canUpload = true;
              vm.filePreviewSrc = img.src;
            }
          } else {
            vm.showErrorMsg = true;
            vm.fileTips = '檔案過大，需小於1mb';
          }
        };
      } else {
        this.showErrorMsg = true;
        this.fileTips = '不正確的檔案類型';
      }
    },

    handleChange() {
      this.avatarFiles = this.$refs.userAvatar.files;
      this.handleUploadFile();
    },

    handleDragEnter() {
      this.fileOnDrag = true;
    },

    handleDragLeave() {
      this.fileOnDrag = false;
    },

    handleDragDrop() {
      this.fileOnDrag = false;
    },

    startUploadFileProcess() {
      this.showLoading = true;

      const fileType = this.avatarFiles[0].type === 'image/jpeg' ? 'jpg' : 'png';
      const timeStamp = new Date().getTime();

      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const formData = new FormData();

      formData.append(
        'thumbSrc',
        this.avatarFiles[0],
        `${this.loginProfile.user_type}${this.loginDjangoId}_${timeStamp}.${fileType}`,
      );

      putAvatarUpload('', formData, {
        headers: {
          'content-Type': 'multipart/form-data',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      }).then((response) => {
        console.log('更新大頭貼成功!!', response.data);

        getAvatarHistory('', {
          headers: {
            'content-Type': 'multipart/form-data',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        }).then((/* response */) => {
          console.log('成功記錄使用者頭像');

          this.changePopBoxStatus({
            active: true,
            include: 'updateConfirm',
          });

          this.showLoading = false;

          setTimeout(() => {
            this.changePopBoxStatus({
              active: false,
              include: '',
            });
          }, this.POP_DURATION);
        }).catch((error) => {
          // console.log('Axios putAvatarUpload Error', error.message);
          if (error.response.status === 401) {
            this.changePopBoxStatus({
              active: true,
              include: 'relogin',
            });
          }
          this.showLoading = false;
        });
      })
        .catch((/* error */) => {
          // console.log('Axios putAvatarUpload Error', error.message);
        });
    },

    removeUploadFileProcess() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      removeAvatarUpload(`/?pk=${this.loginDjangoId}`, {
        headers: {
          'content-Type': 'multipart/form-data',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      }).then((/* response */) => {
        console.log('刪除大頭貼成功!!');
        this.changePopBoxStatus({
          active: true,
          include: 'updateConfirm',
        });
        setTimeout(() => {
          this.handleClosePopBox();
          // this.$router.go(this.$router.currentRoute);
          // 更新User Store State
          GlobalEmitter.emit('force-root-update', {
            event: 'userProfile-refresh',
          });
        }, this.POP_DURATION);
      })
        .catch((error) => {
          // console.log('Axios removeAvatarUpload Error', error.message);
          if (error.response.status === 401) {
            this.changePopBoxStatus({
              active: true,
              include: 'relogin',
            });
          }
        });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginProfile: 'user/exportUserProfile',
      loginDjangoId: 'user/exportUserDjangoId',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },
};

</script>
<style module lang='scss'>
@import '../../../sass/component/page/popbox/popAvatarUploader.scss';
</style>
